import { create } from 'zustand';

export interface AuthUser {
  id: string;
  email: string;
  name: string;
}

interface AuthState {
  currentUser: AuthUser | null;
  loaded: boolean;
  loading: boolean;
  setCurrentUser: (user: AuthUser | null) => void;
  fetchCurrentUser: () => Promise<AuthUser | null>;
  clear: () => void;
}

export const useAuthStore = create<AuthState>((set, get) => ({
  currentUser: null,
  loaded: false,
  loading: false,

  setCurrentUser: (user) => set({ currentUser: user, loaded: true }),

  fetchCurrentUser: async () => {
    if (get().loading) return get().currentUser;
    set({ loading: true });
    try {
      const res = await fetch('/api/auth/me', {
        method: 'GET',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
      });
      if (!res.ok) {
        set({ currentUser: null, loaded: true, loading: false });
        return null;
      }
      const user = (await res.json()) as AuthUser;
      set({ currentUser: user, loaded: true, loading: false });
      return user;
    } catch {
      set({ currentUser: null, loaded: true, loading: false });
      return null;
    }
  },

  clear: () => set({ currentUser: null, loaded: false, loading: false }),
}));
